import styled, { keyframes } from "styled-components";

export const StyledTextInput = styled.input`
  border: none;
  color: #b9b9c6;
  font-size: 12px;
  font-weight: 400;
  width: 100%;

  &:focus {
    outline: none;
    color: #0e0e2c;
  }
`;

export const StyledFormInputCheckbox = styled.input`
  width: 16px;
  height: 16px;
`;

export const StyledErrorInFieldDiv = styled.div`
  position: absolute;
  top: 60px;
  color: #cf324a;
  font-feature-settings:
    "liga" off,
    "clig" off;

  /* Text2 (14px)/Normal */
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const StyledFormInput = styled.input`
  background: var(--CLOUD, #fcfdfe);
  border-radius: 4px;
  border: 1px solid
    ${({ $variant }) => ($variant === "light" ? "#ECF1F4" : "var(--LIGHT-ASH, #b9b9c6)")};
  color: var(--ASH, #676879);
  font-size: 14px;
  font-weight: 400;
  height: 32px;
  line-height: 22px;
  margin-bottom: 4px;
  padding: 8px 4px 8px 12px;
  width: 100%;

  &:focus,
  &:focus-visible {
    border: 1px solid var(--DARK-BLUE, #1249bf);
    outline: none;
  }

  &:disabled {
    opacity: 0.25;
  }

  &::placeholder {
    color: var(--ASH, #676879);
    opacity: 0.65;
  }
`;

export const StyledFormTableInput = styled.input`
  background: var(--CLOUD, #fcfdfe);
  border-radius: 4px;
  border: 1px solid var(--LIGHT-ASH, #b9b9c6);
  color: var(--ASH, #676879);
  padding-right: 4px;
  width: 100%;

  &:disabled {
    opacity: 0.25;
  }

  &::placeholder {
    color: var(--ASH, #676879);
    opacity: 0.65;
  }
`;

export const StyledFormFileInput = styled.div`
  background: var(--MIST, #f7f8f9);
  border-radius: 2px;
  border: 1px dashed #d9d9d9;
  cursor: pointer;
  margin: 16px 0;
  outline: none;
  padding: 32px 16px;
  position: relative;
  text-align: center;
  user-select: none;
  transition:
    border-color 0.15s ease,
    background 0.15s ease;

  ${p =>
    p.$active &&
    `
    background: #eef4ff;
    border-color: #6b8cff;
  `}

  &:hover {
    border-color: #9aa1ae;
  }

  &:focus-visible {
    box-shadow: 0 0 0 3px rgba(104, 145, 255, 0.35);
  }
`;

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

export const FileInputSpinner = styled.span`
  display: inline-block;
  width: 1em;
  height: 1em;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${spin} 0.6s linear infinite;
`;

export const StyledFormSwitchDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--Light---primary-text-color, #323338);
  margin-bottom: 4px;
  .ant-switch {
    background: var(--LIGHT-GREY, #8c8ca1) !important;
    height: ${props => (props.size === "small" ? "auto" : "24px !important")};
    & ::before {
      top: 1px !important;
    }
  }
  .ant-switch-checked {
    background: var(--BLUE, #2060ea) !important;
  }
`;

export const StyledFormRadioDiv = styled.div`
  color: var(--ASH, #676879);
  text-overflow: ellipsis;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 157.143% */
  .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
    background-color: #2060ea;
    border-color: #2060ea;
  }
  .ant-radio-wrapper {
    color: var(--ASH, #676879);
    font-family: Inter;
  }
  &.dirCol .ant-radio-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
  .radioOption {
    width: 100%;
    &:hover {
      border-bottom: 1px solid #e9edf5;
      background: #f7f8f9;
    }
  }
`;

export const StyledPhoneContainer = styled.div`
  .PhoneInput {
    display: flex;
    align-items: center;
    background: var(--CLOUD, #fcfdfe);
    border-radius: 4px;
    border: 1px solid var(--LIGHT-ASH, #b9b9c6);
    height: 32px;
    margin-bottom: 4px;
    width: 100%;
    transition: all 0.2s;
  }

  .PhoneInputCountry {
    display: flex;
    align-items: center;
    padding: 0 8px;
    border-right: 1px solid var(--LIGHT-ASH, #b9b9c6);
    height: 100%;
  }

  .PhoneInputCountryIcon {
    width: 20px;
    height: 15px;
  }

  .PhoneInputCountryIcon--square {
    width: 1em;
  }

  .PhoneInputCountryIcon--border {
    background-color: transparent;
    box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5) inset;
  }

  .PhoneInputCountryIconImg {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .PhoneInputCountrySelectArrow {
    display: block;
    content: "";
    width: 0.3em;
    height: 0.3em;
    margin-left: 0.3em;
    border-style: solid;
    border-color: inherit;
    border-top-width: 0;
    border-bottom-width: 1px;
    border-left-width: 0;
    border-right-width: 1px;
    transform: rotate(45deg);
    opacity: 0.45;
  }

  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    border: 0;
    opacity: 0;
    cursor: pointer;
  }

  .PhoneInputInput {
    flex: 1;
    border: none;
    background: transparent;
    padding: 8px 4px 8px 12px;
    color: var(--ASH, #676879);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    outline: none;

    &::placeholder {
      color: var(--ASH, #676879);
      opacity: 1;
    }

    &:disabled {
      opacity: 0.25;
    }
  }
  .forTable {
    border: none;
    .PhoneInputInput {
      font-size: 10px;
    }
  }
`;

export const StyledInputSuffixContainer = styled.div`
  display: flex;
  align-items: center;
  background: var(--CLOUD, #fcfdfe);
  border-radius: 4px;
  border: 1px solid var(--LIGHT-ASH, #b9b9c6);
  height: 32px;
  margin-bottom: 4px;
  width: 100%;
  padding: 0 12px;
  box-sizing: border-box;

  input {
    flex: 1;
    border: none;
    background: transparent;
    padding: 8px 4px 8px 0;
    color: var(--ASH, #676879);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    outline: none;
    min-width: 0;

    &:disabled {
      opacity: 0.25;
    }

    &::placeholder {
      color: var(--ASH, #676879);
      opacity: 0.65;
    }
  }

  .suffix-text {
    color: var(--ASH, #676879);
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    white-space: nowrap;
    user-select: none;
    padding-left: 4px;
  }
`;

export const StyledUploadContainer = styled.div`
  width: 170px;
  height: 162px;
  position: relative;

  .upload-label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    width: 100%;
    height: 100%;
    cursor: pointer;
    transition: background-color 0.2s ease;
    border-radius: 2px;
    border: 1px dashed #d9d9d9;
    background: var(--MIST, #f7f8f9);

    &:hover {
      background: #f0f2f5;
    }

    svg {
      width: 20px;
      height: 20px;
      fill: var(--GREY, #4a4a68);
    }

    span {
      color: var(--GREY, #4a4a68);
      text-align: center;
      font-family: Inter;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: 22px;
    }
  }

  .preview-container {
    position: relative;
    width: 100%;
    height: 100%;
    border: 1px solid #e4e4e4;
    border-radius: 2px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;

    img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }

    .remove-btn {
      position: absolute;
      top: 8px;
      right: 8px;
      background: rgba(0, 0, 0, 0.6);
      color: #fff;
      border: none;
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      font-size: 12px;
      line-height: 1;
      padding: 0;
      transition: background-color 0.2s ease;

      &:hover {
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }
`;
